App.addModule(function(app) {

    app.on('loaded', () => {
        $(document).tooltip({
		    selector: '[data-toggle="tooltip"]'
	    });
    })
})
